(function(){
'use strict';

angular.module('classy').component('formTable', {
  template: '<div class="form-table" data-ng-transclude></div>',
  transclude: true
});
})();